var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5 8.85156H2.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.18359V5.51693M6.66667 2.18359V5.51693M6.5 18.8503H13.5C14.9001 18.8503 15.6002 18.8503 16.135 18.5778C16.6054 18.3381 16.9878 17.9556 17.2275 17.4852C17.5 16.9505 17.5 16.2504 17.5 14.8503V7.85026C17.5 6.45013 17.5 5.75006 17.2275 5.21528C16.9878 4.74488 16.6054 4.36243 16.135 4.12274C15.6002 3.85026 14.9001 3.85026 13.5 3.85026H6.5C5.09987 3.85026 4.3998 3.85026 3.86502 4.12274C3.39462 4.36243 3.01217 4.74488 2.77248 5.21528C2.5 5.75006 2.5 6.45013 2.5 7.85026V14.8503C2.5 16.2504 2.5 16.9505 2.77248 17.4852C3.01217 17.9556 3.39462 18.3381 3.86502 18.5778C4.3998 18.8503 5.09987 18.8503 6.5 18.8503Z",
    stroke: "#00E0FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.dd187fbf46e3e54f0b9ab7f4369700bf.svg";
export { ForwardRef as ReactComponent };